export default "__VITE_ASSET__agDCgpFe__"